export default __webpack_public_path__ + "static/media/units_card.b09577ae.jpg";